import { Component, OnInit, ViewChild } from '@angular/core';
import { ApiService } from '../../shared/services/api.service';
import { Document } from '../../entities/document.model';
import { DocumentCategory } from '../../entities/document-category.model';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { LocalStorageService, SessionStorageService } from 'ng2-webstorage';
import { API_SERVER, API_SERVER_VERSION } from '../../app.constants';

@Component({
  selector: 'app-documents',
  templateUrl: './documents.component.html',
  styles: []
})
export class DocumentsComponent implements OnInit {

  private apiUrl = API_SERVER + 'api/' + API_SERVER_VERSION + '/';

  @ViewChild('addCategoryModal') private addCategoryModal;
  @ViewChild('addDocumentModal') private addDocumentModal;

  loadingIndicators: Array<string> = [];

  documents: Document[];
  documentCategories: DocumentCategory[];

  private modalRef: any = null;

  newCategory: DocumentCategory;
  newDocument: Document;
  newDocumentFile: any;

  constructor(private http: HttpClient,
              private apiService: ApiService,
              private modalService: NgbModal,
              private localStorage: LocalStorageService,
              private sessionStorage: SessionStorageService) {
  }

  ngOnInit(): void {
    this.getDocuments();
    this.getCategories();
  }

  getDocuments() {
    this.loadingIndicators.push('documents');
    this.apiService.find<Document>(Document, ['documents'].join('/'))
      .subscribe((documents: Array<Document>) => {
        console.log('documents: ', documents);
        this.documents = documents;
        this.loadingIndicators = this.loadingIndicators.filter(i => i !== 'documents');
      }, e => {
        console.log('error loading documents: ', e);
        this.documents = [];
        this.loadingIndicators = this.loadingIndicators.filter(i => i !== 'documents');
      });
  }

  getCategories(): void {
    this.loadingIndicators.push('document-categories');
    this.apiService.find<DocumentCategory>(DocumentCategory, ['document-categories'].join('/'))
      .subscribe((documentCategories: Array<DocumentCategory>) => {
        this.documentCategories = documentCategories;
        this.loadingIndicators = this.loadingIndicators.filter(i => i !== 'document-categories');
      }, e => {
        this.documentCategories = [];
        this.loadingIndicators = this.loadingIndicators.filter(i => i !== 'document-categories');
      });
  }

  addCategory() {
    this.newCategory = {
      id: null,
      title: '',
      sortOrder: this.documentCategories.length + 1
    };
    this.openModal(this.addCategoryModal, {size: 'sm'});
  }

  addDocument(category: DocumentCategory): void {
    this.newDocument = {
      id: null,
      categoryId: category.id,
      title: '',
      sortOrder: 0
    };
    this.openModal(this.addDocumentModal, {size: 'lg'});
  }

  openModal(modal: any, options: NgbModalOptions) {
    this.modalRef = this.modalService.open(modal, options);
  }

  saveNewCategoy(save: boolean) {
    if (save) {
      this.apiService.postRegular(this.newCategory, 'document-categories').subscribe((response) => {
        console.log('new category saved: ', response);
        this.newCategory = null;
        this.getCategories();
      }, e => {
        console.log('error saving new category', e);
        this.newCategory = null;
        this.getCategories();
      });
    } else {
      this.newCategory = null;
    }
  }

  saveNewDocument(save: boolean): void {
    if (save) {
      let headers = new HttpHeaders();
      const token = this.localStorage.retrieve('authenticationToken') || this.sessionStorage.retrieve('authenticationToken');
      if (token && token.expires_at && token.expires_at > new Date().getTime()) {
        headers = headers.append('Authorization', 'Bearer ' + token.access_token);
      }
      headers = headers.append('content-type', 'multipart/mixed');
      const formData: FormData = new FormData();
      formData.append('document', JSON.stringify(this.newDocument));
      formData.append('file', this.newDocumentFile);
      this.http.post<any>(this.apiUrl + 'documents', formData, { reportProgress: true, observe: 'events', headers: headers })
      .subscribe((response) => {
        console.log('new document saved: ', response);
        this.newDocument = this.newDocumentFile = null;
        this.getDocuments();
      }, e => {
        console.log('error saving new document', e);
        this.newDocument = this.newDocumentFile = null;
        this.getDocuments();
      });
    } else {
      this.newDocument = this.newDocumentFile = null;
    }
  }

  uploadNewDocumentFile(event) {
    this.newDocumentFile = (event.target as HTMLInputElement).files[0];
  }
}



// WEBPACK FOOTER //
// ./src/app/documents/documents/documents.component.ts